<template>
    <div class="steps-holder mx-auto">
            <div class="steps-view">
                <slot></slot>
            </div>
            <div class="actions d-flex justify-content-end">
                <Button 
                    @click.native="changeStep(-1)"
                    style = "padding: 7px" class="justify-content-center align-items-center btn-square btn-outline button-prev" v-show="swiperActiveIndex">
                    <Icon icon = "arrow-back" />
                </Button>
                <Button 
                    :disabled = "hasError && swiperActiveIndex === 0"
                    style = "padding: 7px 20px" 
                    class="justify-content-center align-items-center btn-purple ml-4 button-next" 
                    v-show="swiperActiveIndex<3"
                    @click.native="changeStep(1)"
                >
                    Next
                    <Icon icon = "arrow-next" class="ml-2" />
                </Button>
            </div>
        </div>
</template>

<script>
import Button from '../../../components/Theme/Button'
import Icon from '../../../components/Theme/Icon'
import {ref, computed} from '@vue/composition-api'
import {useErrors, useRouter} from '../../../core/hooks'

export default {
    name: 'StepsHolder',
    components: {
        Button,
        Icon
    },
    props: {
        shop: Object
    },
    setup(props, {emit}){

        const {router} = useRouter()
        const errorHandler = useErrors();
        const hasError = computed(() => errorHandler.hasError() || !props.shop);

        const swiperActiveIndex = ref(0)
        const changeStep = async step => {
            if(step > 0) {
               await emit('validateFields')
            }

            if(hasError.value && step>0){
                return
            }
            swiperActiveIndex.value += step;
            emit('setActiveIndex', swiperActiveIndex.value)
        }

        return {
            swiperActiveIndex,
            changeStep,
            hasError
        }
    }

}
</script>


<style lang="scss" scoped>
    .steps-holder {
        max-width: 800px;
        width: 90%;
        background: #fff;
        border-radius: 10px;
        margin: 90px auto 40px;

        @media screen and (max-height: 900px) {
            transform: scale(0.9);
            margin: 40px auto 0px;
        }

        .steps-view {
            padding: 32px 40px 0; 
            height: 550px;
        }

        .swiper-slide {
            padding: 32px 0!important;
        }

        .actions {
            border-top: 1px solid #E2E8F0;
            padding: 20px 40px;

            button:hover img {
                filter: brightness(1000%);
            }

            button {
                font-size: 14px;
                display: flex;
                cursor: pointer;
            }
        }

        button:disabled {
           opacity: 0.5;
           cursor: default;
           &:hover {
               box-shadow: none;
           } 
        }
    }
    
</style>
